var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcYourInitiatives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.839,
    height: 100,
    viewBox: "0 0 85.839 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic_Your_Initiatives",
    "data-name": "Ic_Your Initiatives",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M55.244,0a3.8,3.8,0,0,1,.634.053l.689,0A3.785,3.785,0,0,1,59.29,1.215l25.5,26.564a3.773,3.773,0,0,1,1.053,2.613v46.14a23.243,23.243,0,0,1-22.4,23.463L23.077,100h-.549A23.085,23.085,0,0,1,0,77.535L0,22.6a23.146,23.146,0,0,1,23-22.547l31.6,0A3.8,3.8,0,0,1,55.244,0ZM51.468,7.606l-28.451,0A15.538,15.538,0,0,0,7.552,22.695V76.532A15.539,15.539,0,0,0,22.7,92.449H63.292a15.705,15.705,0,0,0,15-15.887V35.152l-10.118.005a16.771,16.771,0,0,1-16.7-16.738Zm7.551,4.233v6.579a9.2,9.2,0,0,0,9.162,9.187l5.97-.005Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M20.638,7.6a1.645,1.645,0,0,1,0,2.326L12.09,18.478a1.635,1.635,0,0,1-.9.462l-.259.02a1.646,1.646,0,0,1-1.164-.482L5.615,14.324A1.646,1.646,0,0,1,7.944,12l2.984,2.989L18.313,7.6A1.642,1.642,0,0,1,20.638,7.6Z",
    transform: "translate(9.973 35.665)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M20.483,6.87a2.9,2.9,0,0,1,2.052,4.957l-8.547,8.549a2.871,2.871,0,0,1-1.6.815l-.1.012-.358.024a2.886,2.886,0,0,1-2.054-.851L5.733,16.222a2.907,2.907,0,0,1,0-4.107,2.9,2.9,0,0,1,4.1,0l2.1,2.1L18.431,7.72A2.883,2.883,0,0,1,20.483,6.87ZM12.029,18.7a.377.377,0,0,0,.176-.1l8.55-8.553a.387.387,0,0,0,0-.547.384.384,0,0,0-.545,0l-8.276,8.276L8.061,13.9a.385.385,0,0,0-.274-.113.381.381,0,0,0-.271.112.388.388,0,0,0,0,.55L11.662,18.6a.385.385,0,0,0,.241.112Z",
    transform: "translate(8.965 34.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-3",
    "data-name": "Combined-Shape",
    d: "M20.638,7.6a1.645,1.645,0,0,1,0,2.326L12.09,18.478a1.635,1.635,0,0,1-.9.462l-.259.02a1.646,1.646,0,0,1-1.164-.482L5.615,14.324A1.646,1.646,0,0,1,7.944,12l2.984,2.989L18.313,7.6A1.642,1.642,0,0,1,20.638,7.6Z",
    transform: "translate(9.973 55.8)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline-2",
    "data-name": "Combined-Shape - Outline",
    d: "M20.483,6.87a2.9,2.9,0,0,1,2.052,4.957l-8.547,8.549a2.871,2.871,0,0,1-1.6.815l-.1.012-.358.024a2.886,2.886,0,0,1-2.054-.851L5.733,16.222a2.907,2.907,0,0,1,0-4.107,2.9,2.9,0,0,1,4.1,0l2.1,2.1L18.431,7.72A2.883,2.883,0,0,1,20.483,6.87ZM12.029,18.7a.377.377,0,0,0,.176-.1l8.55-8.553a.387.387,0,0,0,0-.547.384.384,0,0,0-.545,0l-8.276,8.276L8.061,13.9a.385.385,0,0,0-.274-.113.381.381,0,0,0-.271.112.388.388,0,0,0,0,.55L11.662,18.6a.385.385,0,0,0,.241.112Z",
    transform: "translate(8.965 54.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497884",
    "data-name": "Path 497884",
    d: "M4.027,0H16.108a4.027,4.027,0,1,1,0,8.054H4.027A4.027,4.027,0,0,1,4.027,0Z",
    transform: "translate(40.275 45.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497885",
    "data-name": "Path 497885",
    d: "M4.027,0H26.176a4.027,4.027,0,0,1,0,8.054H4.027A4.027,4.027,0,0,1,4.027,0Z",
    transform: "translate(40.275 65.439)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYourInitiatives);
export default __webpack_public_path__ + "static/media/Ic_Your Initiatives.2ffcd625b1158bb6831a86cb14d96fbb.svg";
export { ForwardRef as ReactComponent };